import { LoadingOverlay } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useFetchAssets } from 'src/Hooks/Queries/useFetchAssets';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';

const RedirectToFirstAsset = () => {
  const { data: assets, isLoading: isAssetsLoading, isError: isAssetsError } = useFetchAssets();
  const { data: me, isLoading: isUserLoading } = useFetchUser();
  const [redirectPath, setRedirectPath] = useState<string | undefined>(undefined);

  const isLoading = isAssetsLoading || isUserLoading;

  useEffect(() => {
    if (!isLoading && !isAssetsError) {
      if (assets && assets.length > 0) {
        const favoriteAsset = me?.favoriteAssetId
          ? assets.find(a => a.id === me.favoriteAssetId)
          : undefined;
        const targetAsset = favoriteAsset ?? assets[0];
        setRedirectPath(`/asset/${targetAsset.id}/dashboard`);
      } else {
        setRedirectPath('/onboarding');
      }
    }
  }, [assets, me, isLoading, isAssetsError]);

  if (isLoading) {
    return (
      <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
    );
  }

  if (isAssetsError) {
    return <div>Erreur lors du chargement des assets</div>;
  }

  return redirectPath ? <Navigate to={redirectPath} replace /> : null;
};

export default RedirectToFirstAsset;
